import script from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyModal.vue?vue&type=script&setup=true&lang=js"

import "./CompanyModal.vue?vue&type=style&index=0&id=4f2e0720&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f2e0720"]])

export default __exports__